import { render, staticRenderFns } from "./TenantUserEdit.vue?vue&type=template&id=29347f10"
import script from "./TenantUserEdit.vue?vue&type=script&lang=ts"
export * from "./TenantUserEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports